import React, { useEffect, useState, useCallback } from 'react';
import { GoogleMap, useJsApiLoader, MarkerF } from '@react-google-maps/api';

const googleMapsKey = 'AIzaSyCsEuLdHnu5Iyo1xtAe0xg-VGlZ0_xWyhs';

function SecurityMap({postCreator, coords, showPost, ...props}) {
  const [posts, setPosts] = useState([]);
  const [ready, setReady] = useState(false);
  const [map, setMap] = useState();
  const [myCoords, setMyCoords] = useState(coords || {lat:0, lng:0});
  const [postMarkers, setPostMarkers] = useState([]);
  const baseHeight = '420px';
  const image = {
    url: props.user.avatar,
    scaledSize: {width: 30, height: 30}
  };
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: googleMapsKey
  });

  const onLoad = useCallback(function callback(m) {
    m.setZoom(15);
    setMap(m)
  }, [])

  const onUnmount = useCallback(function callback(map) {
    setMap(null)
  }, [])

  const fetchPosts = async (coordinates=undefined) => {
    console.log('[SecurityMap]  Fetching posts...');
    const loc = coordinates || myCoords;
    // let url = window.location.protocol + '//' + window.location.host;
    try {
      const d = await fetch(`/api/v1/posts?post_category=Segurança&loc[]=${loc.lng}&loc[]=${loc.lat}`);
      d.json().then(data => {
        if (data) {
          let parsedBody = data;
          console.log('[SecurityMap] Got data...');
          if (parsedBody && parsedBody['posts']) {
            const newPosts = posts.concat(parsedBody['posts']);
            setPosts(newPosts);
          } else if (parsedBody && Object.keys(parsedBody).includes('posts')) {
            setReady(true);
          }
        } else {
          console.log('Got nothing: err is: ' + err);
        }
      });
    } catch(e) {
      console.log('Post fetch unsuccessful.');
      console.log('Error is: ' + e);
      if ( e.statusCode && e.statusCode === 401) {
        // Show login page..
        console.log('  Got 401.. Need to login');
        refresh();
      }
    }
  }

  useEffect(() => {
    getPosition();
    // let coords = coords || {lat: 0, lng: 0};
    let pms = '';
    if (posts) {
      pms = [];
      for (let i = 0; i < posts.length; i++) {
        let opacity = 1.0;
        let timestamp = new Date(posts[i].created_at).getTime();
        let now = new Date().getTime();
        if ((now - timestamp) > 86400000) {
          opacity = 0.5;
        }
        let title = posts[i].title + '\n' + posts[i].created_at;
        pms.push(
           <MarkerF key={posts[i]._id['$oid']} opacity={opacity} defaultOpacity={opacity}
                   title={title}
                   onClick={(e) => showPost(e, posts[i])}
                   position={{lat: posts[i].location[1], lng: posts[i].location[0]}} />
        );
      }
      setPostMarkers(pms);
    }
  }, []);

  const savePosition = async (coords) => {
    if (coords.coords) {
      await setMyCoords({lng: coords.coords.longitude, lat: coords.coords.latitude});
      fetchPosts({lng: coords.coords.longitude, lat: coords.coords.latitude});
    } else {
      failPosition();
    }
  }

  const failPosition = () => {
    if (props?.user?.location) {
      setMyCoords({lng: props.user.location[0], lat: props.user.location[1]}, function() {
        fetchPosts();
      });
    }
  };

  const getPosition = () => {
    // What a crap API navigator.geolocation is...  Do not try to try/catch it.
    navigator.geolocation.getCurrentPosition(savePosition, failPosition);
  }

  const pickLocation = (e) => {
    if (postCreator) {
      postCreator.setLocation({loc: [e.latLng.lng(), e.latLng.lat()]});
    }
  }

  return (
    <div style={{'paddingBottom': '28px', 'marginTop': '14px', 'width': '516px', 'height': props.height || baseHeight}}>
      <span className='genericLabel'>Eventos Recentes</span>
      <p />
      { isLoaded ?
        <GoogleMap zoom={15} mapContainerStyle={{width: '518px', height: '400px'}}
                   onLoad={onLoad} onUnmount={onUnmount}
                   center={myCoords} image={image}>
           {postMarkers}
           <MarkerF position={myCoords} icon={image} />
        </GoogleMap>
        : 'Loading...'
      }
    </div>
  );
}

export default SecurityMap;
